import { render, staticRenderFns } from "./FireCauseExternOrigin.vue?vue&type=template&id=48517dc6&scoped=true"
import script from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseExternOrigin.vue?vue&type=style&index=0&id=48517dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48517dc6",
  null
  
)

export default component.exports